<template>
  <div>
    <Row align="middle" type="flex" class-name="column-bar">
      <Col span="3">
      <column-title :title="$t('pages_dashboards_statement_sale_index_395')" class="column-bar__tit"/>
      </Col>
      <Col span="21">
      <tabs-time-picker :time.sync="currentTime" @change="changeTime"/>
      </Col>
    </Row>
    <Summary :data="statement_sale_summary" ></Summary>
    <Row align="middle" type="flex" class-name="column-bar">
      <Col span="4">
      <column-title :title="$t('pages_dashboards_statement_sale_index_396')" class="column-bar_tit"/>
      </Col>
      <Col span="20">
      </Col>
    </Row>
    <Row align="middle" type="flex" class-name="column-bar">
      <Col span="22">
        <Menu mode="horizontal" :active-name="activeName" @on-select="selectMenu">
          <Submenu name="1">
              <template slot="title">
                  <Icon type="ios-stats" />{{$t('pages_dashboards_statement_sale_index_397')}}</template>
                  <MenuItem name="frontSaleDetail">{{$t('pages_dashboards_statement_sale_index_398')}}</MenuItem>
                  <MenuItem name="frontDiscountDetail">{{$t('pages_dashboards_statement_sale_index_399')}}</MenuItem>
                  <MenuItem name="frontRevenueDetail">{{$t('pages_dashboards_statement_sale_index_400')}}</MenuItem>
          </Submenu>
          <Submenu name="3">
            <template slot="title">
                <Icon type="ios-stats" />{{$t('pages_dashboards_statement_sale_index_401')}}</template>
                <MenuItem name="wechatSaleDetail">{{$t('pages_dashboards_statement_sale_index_398')}}</MenuItem>
                <MenuItem name="wechatDiscountDetail">{{$t('pages_dashboards_statement_sale_index_399')}}</MenuItem>
        </Submenu>
        </Menu>
      </Col>
      <Col span="2">
        <el-button
          type="primary"
          size="medium"
          @click="exportData"
          icon="el-icon-download"
        >{{$t('pages_customers_index_311')}}</el-button>
      </Col>
    </Row>
    <i-table
        v-for="(item, name) of columns"
        :key="name"
        v-show="name === activeName"
        :ref="name"
        :highlight-row="true"
        :columns="item"
        :data="statement_sale_table_data[name]">
    </i-table>
  </div>
</template>
<script>
import i18n from '../../../locales/index'

import ColumnTitle from '_c/column-title'
import TabsTimePicker from '_c/tabs-time-picker'
import Summary from './components/summary'
import { mapGetters, mapActions, mapState } from 'vuex'
export default {
  name: 'home',
  components: {
    ColumnTitle,
    TabsTimePicker,
    Summary
  },
  data () {
    return {
      activeName: 'frontSaleDetail',
      currentTime: [],
      columns: {
        frontSaleDetail: [
          {
            key: "duration",
            title: i18n.t('pages_dashboards_statement_product_index_374')
          },
          {
            key: 'front_orders_total',
            title: i18n.t('pages_dashboards_statement_sale_index_402'),
          },
          {
            key: 'front_orders_finish_total',
            title: i18n.t('pages_dashboards_statement_sale_index_403'),
          },
          {
            key: 'front_orders_discount_total',
            title: i18n.t('pages_dashboards_statement_sale_index_404'),
          },
          {
            key: 'front_orders_size',
            title: i18n.t('pages_dashboards_statement_sale_components_summary_386'),
          },
          {
            key: 'front_orders_unit_revenue',
            title: i18n.t('pages_dashboards_statement_sale_index_405'),
          },
          {
            key: 'front_orders_refund_size',
            title: i18n.t('pages_dashboards_statement_sale_index_406'),
          },
          {
            key: 'front_orders_refund_sale',
            title: i18n.t('pages_dashboards_statement_sale_index_407'),
          }
        ],
        frontDiscountDetail: [
          {
            key: "duration",
            title: i18n.t('pages_dashboards_statement_product_index_374')
          },
          {
            key: 'discount',
            title: i18n.t('pages_dashboards_statement_sale_index_408'),
          },
          {
            key: 'small_discounted_amount',
            title: i18n.t('pages_dashboards_statement_sale_index_409'),
          },
          {
            key: 'custom_percentage_discount',
            title: i18n.t('pages_dashboards_statement_sale_index_410'),
          },
          {
            key: 'customer_discounted_total',
            title: i18n.t('pages_dashboards_statement_sale_index_411'),
          },
          {
            key: 'enough_consume_discount',
            title: i18n.t('pages_dashboards_statement_sale_index_412'),
          }
        ],
        frontRevenueDetail: [
          {
            key: "duration",
            title: i18n.t('pages_dashboards_statement_product_index_374')
          },
          {
            key: 'finish_total',
            title: i18n.t('pages_dashboards_statement_sale_index_413'),
          },
          {
            key: 'cash_pay',
            title: i18n.t('libs_table_render_74'),
          },
          {
            key: 'lcsw_ali_pay',
            title: i18n.t('pages_dashboards_statement_sale_index_414'),
          },
          {
            key: 'lcsw_wx_pay',
            title: i18n.t('pages_dashboards_statement_sale_index_415'),
          },
          {
            key: 'svc_pay',
            title: i18n.t('libs_table_render_82'),
          },
          {
            key: 'bank_card',
            title: i18n.t('libs_table_render_75'),
          },
          {
            key: 'alipay_offline',
            title: i18n.t('libs_table_render_79'),
          },
          {
            key: 'wx_pay_offline',
            title: i18n.t('libs_table_render_80'),
          },
          {
            key: 'meituan_pay_offline',
            title: i18n.t('pages_dashboards_statement_sale_index_416'),
          }
        ],
        wechatSaleDetail: [
          {
            key: "duration",
            title: i18n.t('pages_dashboards_statement_product_index_374')
          },
          {
            key: 'wechat_orders_total',
            title: i18n.t('pages_dashboards_statement_sale_index_417'),
          },
          {
            key: 'wechat_orders_finish_total',
            title: i18n.t('pages_dashboards_statement_sale_index_418'),
          },
          {
            key: 'wechat_orders_discount_total',
            title: i18n.t('pages_dashboards_statement_sale_index_419'),
          },
          {
            key: 'wechat_orders_size',
            title: i18n.t('pages_dashboards_statement_sale_components_summary_388'),
          },
          {
            key: 'wechat_orders_unit_revenue',
            title: i18n.t('pages_dashboards_statement_sale_index_420'),
          },
          {
            key: 'wechat_orders_refund_size',
            title: i18n.t('pages_dashboards_statement_sale_index_421'),
          },
          {
            key: 'wechat_orders_refund_sale',
            title: i18n.t('pages_dashboards_statement_sale_index_422'),
          }
        ],
        wechatDiscountDetail: [
          {
            key: "duration",
            title: i18n.t('pages_dashboards_statement_product_index_374')
          },
          {
            key: 'discount',
            title: i18n.t('pages_dashboards_statement_sale_index_423'),
          },
          {
            key: 'finish_total',
            title: i18n.t('pages_dashboards_statement_product_components_summary_362'),
          }
        ]
      }
    }
  },
  computed: {
    ...mapGetters('dashboard', ['statement_sale_summary', 'statement_sale_table_data']),
    ...mapState('dashboard', ['statement_sale_data'])
  },
  methods: {
    ...mapActions('dashboard', ['getStatementSale']),
    async exportData () {
      const filenameMap = new Map([
        ['frontSaleDetail', i18n.t('pages_dashboards_statement_sale_index_424')],
        ['frontDiscountDetail', i18n.t('pages_dashboards_statement_sale_index_425')],
        ['frontRevenueDetail', i18n.t('pages_dashboards_statement_sale_index_426')],
        ['wechatSaleDetail', i18n.t('pages_dashboards_statement_sale_index_427')],
        ['wechatDiscountDetail', i18n.t('pages_dashboards_statement_sale_index_428')],
      ])
      this.$refs[this.activeName][0].exportCsv({
        columns: this.columns[this.activeName],
        data: this.statement_sale_table_data[this.activeName],
        filename: filenameMap.get(this.activeName)
      })
    },
    selectMenu (data) {
      this.activeName = data;
    },
    changeTime (data) {
      console.log(this.currentTime);
      this.getStatementSale({
        start_at: this.currentTime[0],
        end_at: this.currentTime[1]
      });
    }
  },
  created () {},
  mounted () {},
  destroyed () {}
}
</script>

<style lang="less" scoped>
.column-bar{
  margin-bottom: 20px;
  padding-bottom: 10px;
  background: #fff;
  &__tit{
    margin-left: 10px;
  }
}
.count-head {
  font-size: 20px;
}
.count-sub {
  font-size: 16px;
}
</style>
